export enum Country {
    DE = 'de',
    AT = 'at',
    CH = 'ch',
    FR = 'fr',
}
